function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.84375 11.2734C0.40625 11.7188 0.382812 12.5391 0.859375 13.0078C1.33594 13.4844 2.14844 13.4688 2.59375 13.0234L7 8.61719L11.3984 13.0156C11.8594 13.4844 12.6562 13.4766 13.125 13C13.6016 12.5312 13.6016 11.7344 13.1406 11.2734L8.74219 6.875L13.1406 2.46875C13.6016 2.00781 13.6016 1.21094 13.125 0.742188C12.6562 0.265625 11.8594 0.265625 11.3984 0.726562L7 5.125L2.59375 0.71875C2.14844 0.28125 1.32812 0.257812 0.859375 0.734375C0.390625 1.21094 0.40625 2.02344 0.84375 2.46875L5.25 6.875L0.84375 11.2734Z"
});

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.12e6642a.svg";
export { ForwardRef as ReactComponent };